// @mui material components
import {
  Snackbar,
  Alert,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Button,
  ListItemAvatar,
  Avatar,
  Grid,
  Typography,
  Box,
  ListItem,
  ListItemText,
  ListItemIcon,
  List,
  DialogActions,
  Dialog,
  DialogContent,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

import AppConfig from "appConfig";

function RetweetCampaignViewPage() {
  const pageTitle = "Retweet Campaign";
  usePageTitle(pageTitle);

  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [campaign, setCampaign] = useState(null);
  const [profiles, setProfiles] = useState([]);
  const [openSuccessDialog, setOpenSuccessDialog] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/smm/retweet/campaigns/${ref}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          if (result.data.status === "success") {
            setCampaign(result.data.data.campaign);
            setProfiles(result.data.data.profiles);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
          setPageLoaded(true);
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  function getProgressColor(count, target) {
    const progress = count > 0 ? parseInt(((count / target) * 100).toFixed(0), 10) : 5;
    let color = "dark";
    if (progress <= 25) {
      color = "primary";
    } else if (progress > 25 && progress <= 50) {
      color = "warning";
    } else if (progress > 50) {
      color = "success";
    }

    return color;
  }

  async function submitAction(profileReference) {
    setShowLoading(true);

    const json = {
      reference: campaign.reference,
      profile: profileReference,
    };

    await axios
      .post("agents/smm/retweet/campaigns/claim.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          // setSeverity("success");
          setErrMsg(result.data.data.message);
          // setOpen(true);

          setOpenSuccessDialog(true);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine ? "" : "Make sure you have an active internet connection"
          }`
        );
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openSuccessDialog} fullWidth maxWidth="xs">
        <DialogContent>
          <MDBox mt={3} align="center" mb={3}>
            <MDBox>
              <Box mt={1}>
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <CircularProgress
                    variant="determinate"
                    size={120}
                    thickness={2}
                    color="success"
                    value={100}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon color="success" fontSize="large">
                      check
                    </Icon>
                  </Box>
                </Box>
              </Box>
            </MDBox>
            <MDBox mt={2}>
              <MDTypography variant="h6" fontWeight="light">
                {errorMsg}
              </MDTypography>
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenSuccessDialog(false);
            }}
            color="dark"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>

      {pageLoaded && (
        <MDBox pt={3} pb={3}>
          <MDBox mb={2} display="flex" justifyContent="space-between">
            <MDBox>
              <Button
                color="dark"
                size="small"
                startIcon={<Icon>west</Icon>}
                onClick={() => {
                  navigate(`/retweet-campaigns`);
                }}
              >
                Back
              </Button>
            </MDBox>
          </MDBox>
          <MDBox mt={1}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={8} lg={8}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3} align="center">
                    <MDBox>
                      <MDBox>
                        <ListItemAvatar>
                          <Avatar
                            alt="post platform"
                            src={`${AppConfig.api_media_url}${campaign.platform.logo}`}
                          />
                        </ListItemAvatar>
                      </MDBox>
                      <MDBox mt={1}>
                        <MDTypography variant="h6" fontWeight="light" fontSize={14}>
                          {campaign.post_url}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                    <MDBox mt={2}>
                      <MDTypography variant="h6" fontWeight="light" fontSize={14}>
                        <b>Commission:</b> {campaign.currency}
                        {(campaign.commission / 100).toLocaleString("en", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        })}
                      </MDTypography>
                    </MDBox>
                    <MDBox mt={3}>
                      <MDButton
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                          window.open(campaign.post_url, "_blank").focus();
                        }}
                      >
                        {campaign.action.a} Post
                      </MDButton>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
              <Grid item xs={12} md={4} lg={4}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <MDBox p={3}>
                    <MDBox align="center">
                      <MDBox>
                        <Box mt={3} sx={{ position: "relative", display: "inline-flex" }}>
                          <CircularProgress
                            variant="determinate"
                            size={100}
                            thickness={3.6}
                            value={
                              campaign.count > 0
                                ? parseInt((campaign.count / campaign.target) * 100, 10)
                                : 5
                            }
                            color={getProgressColor()}
                          />
                          <Box
                            sx={{
                              top: 0,
                              left: 0,
                              bottom: 0,
                              right: 0,
                              position: "absolute",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Typography
                              variant="caption"
                              component="div"
                              sx={{ color: "text.secondary" }}
                              fontSize={18}
                            >
                              <b>{`${((campaign.count / campaign.target) * 100).toFixed(0)}%`}</b>
                            </Typography>
                          </Box>
                        </Box>
                        <MDTypography variant="h6" fontWeight="regular" fontSize={14}>
                          Completed
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Card>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox mt={5}>
            <Card sx={{ height: "100%", marginTop: "0px" }}>
              <MDBox p={2}>
                {profiles.length <= 0 ? (
                  <MDBox align="center">
                    <Icon>not_interested</Icon>
                    <MDTypography variant="h6" fontSize={14} fontWeight="light">
                      You have not linked any {campaign.platform.title} accounts.
                    </MDTypography>
                  </MDBox>
                ) : (
                  <MDBox>
                    <MDBox mb={3}>
                      <MDTypography variant="h6">
                        I have {campaign.action.b} this post:
                      </MDTypography>
                      <MDTypography variant="h6" fontSize={14} fontWeight="light">
                        Select the {campaign.platform.title} account used.
                      </MDTypography>
                    </MDBox>
                    <List>
                      {profiles.map((profile) => (
                        <MDBox mb={2}>
                          <ListItem>
                            <ListItemIcon>
                              <img
                                src={`${AppConfig.api_media_url}${campaign.platform.logo}`}
                                alt=""
                                width={24}
                              />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                                  {profile.handle}
                                </MDTypography>
                              }
                            />
                            <MDBox>
                              <MDBox mt={0} align="right">
                                <MDButton
                                  variant="contained"
                                  iconOnly
                                  circular
                                  color="primary"
                                  onClick={() => {
                                    submitAction(profile.reference);
                                  }}
                                >
                                  <Icon>check</Icon>
                                </MDButton>
                              </MDBox>
                            </MDBox>
                          </ListItem>
                        </MDBox>
                      ))}
                    </List>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </MDBox>
        </MDBox>
      )}
      <Footer />
    </DashboardLayout>
  );
}

export default RetweetCampaignViewPage;
